/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { format } from "date-fns";
import { Accordion, AccordionSummary, Grid } from "@material-ui/core";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import KeyValueDisplay from "../Common/KeyValueDisplay";
import DOMPurify from "dompurify";
import AttachmentItem from "./AttachmentItem";

const EmailItem = ({ classes, email, isExpanded, handleToggleEmail, handleDownloadAttachment }) => {
	return (
		<Accordion
			expanded={isExpanded || false}
			onChange={() => handleToggleEmail(email.messageId)}
			className={classes.email + (email.direction === "inbound" ? ` ${classes.inbound}` : "")}
		>
			<AccordionSummary
				className={classes.accordionSummary}
				expandIcon={<ExpandMoreIcon />}
				classes={{
					root: classes.accordionSummaryRoot,
					content: classes.accordionSummaryContent,
				}}
				title={email.subject}
			>
				<div className={classes.summaryItem}>
					<div className={classes.itemSubject}>{email.subject}</div>
					<div className={classes.itemPreview}>{email.bodyText.substring(0, 100)}</div>
					{email.attachments && email.attachments.length > 0 && (
						<div className={classes.itemHasAttachment}>
							<i className="fas fa-paperclip"></i>
						</div>
					)}
					<div className={classes.itemDate}>{format(new Date(email.date), "MM/dd/yy hh:mm a")}</div>
				</div>
			</AccordionSummary>

			<div className={classes.emailItem}>
				{email.attachments && email.attachments.length > 0 && (
					<Grid container className={classes.attachmentsContainer}>
						{email.attachments.map((attachment, idx) => (
							<Grid key={idx} item xs={12} md={6} lg={4}>
								<AttachmentItem
									attachment={attachment}
									handleDownload={() => handleDownloadAttachment(email, attachment)}
									classes={classes}
								/>
							</Grid>
						))}
					</Grid>
				)}

				<KeyValueDisplay label="From" node={email.from} row />
				<KeyValueDisplay label="To" node={email.to.join(", ")} row />
				{email.cc && email.cc.length > 0 && <KeyValueDisplay label="Cc" node={email.cc.join(", ")} row />}
				<p
					className={classes.body}
					dangerouslySetInnerHTML={{
						__html: DOMPurify.sanitize(email.bodyHtml || email.bodyText),
					}}
				/>
			</div>
		</Accordion>
	);
};

export default React.memo(EmailItem);
